export class DanglingDossierDb {
	dossierId:number = 0;
	dossierName:string = "";
	companyId:number = 0;
	companyName:string = "";
	activeUntil:null | Date = null;
	deletionReasons:string[] = [];

	public constructor(data?:any) {
		if (!data) return;
		this.dossierId = data.dossierId;
		this.dossierName = data.dossierName;
		this.companyId = data.companyId;
		this.companyName = data.companyName;
		if (data.activeUntil) {
			this.activeUntil = new Date(data.activeUntil * 1000);
		}
		this.deletionReasons = data.deletionReasons || [];
	}

}